import { BuyerAPI } from 'primsell-shared-layer/api'

export const fetchNonceSaga = async (
  address: string,
  cb: ({ message }: { message: string | Uint8Array; dateFetched: string; nonce: string }) => void
): Promise<void> => {
  const {
    data: {
      data: { message, date, nonce },
    },
  } = await BuyerAPI.getNonce({ wallet: address })

  cb({ message, dateFetched: date, nonce })
}

export const validateSignature = async ({
  wallet,
  signature,
  date,
  message,
  cb,
}: {
  wallet: string
  signature: string
  date: string
  message: string
  cb: ({ wallet }: { wallet: string }) => void
}): Promise<void> => {
  const {
    data: {
      data: { token },
    },
  } = await BuyerAPI.getToken({ wallet, signature, date, message })
  localStorage.setItem('payment_token', token)
  cb({ wallet })
}

export const getBuyerData = async (
  address: string,
  cd: ({ firstName, lastName, email }: { address: string; firstName: string; lastName: string; email: string }) => void
): Promise<void> => {
  const {
    data: { data },
  } = await BuyerAPI.getBuyersData()
  cd({
    address,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
  })
}
